<mat-toolbar class="bg-tricon-beige">
    Two Years Required
    <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<mat-dialog-content>
    <p>Tricon requires two years of residency history. Would you like to enter another residence to fulfill this requirement?</p>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col justify-center w-full">
    <div class="w-full">
        <div>
            <button mat-flat-button style="width:100%" color="primary" mat-dialog-close mat-dialog-close="yes">YES</button>
        </div>
        <div>
            <button mat-flat-button style="width:100%" class="mt-4" color="primary" mat-dialog-close mat-dialog-close="no">NO</button>
        </div>
    </div>
</mat-dialog-actions>
